import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../../../../types/upload-field'
import TagsField from '../../../../../form-fields/upload/tags'
import { CreationCaptureInfoContext } from '../manager'

const Tags = styled(TagsField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolUploadField
}

const CreationCaptureInfoPrivacyField = ({ field }: Props) => {
    const { tags, addTags, removeTag, toggleFeaturedTag, enableFeaturedTags } = useContext(CreationCaptureInfoContext)
    return (
        <Tags
            {...{
                field,
                tags,
                onAdd: addTags,
                onRemove: removeTag,
                onToggleFeatured: toggleFeaturedTag,
                enableFeatured: enableFeaturedTags,
            }}
        />
    )
}

export default CreationCaptureInfoPrivacyField
